import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitPrive = async (data) => {
  const response = await fetch("/api/enquiries/prive.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (!response.ok || !result.success) {
    throw new Error(result.message || "Failed to send enquiry");
  }

  return result;
};

export const submitCollective = async (data) => {
  const response = await fetch("/api/enquiries/collective.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (!response.ok || !result.success) {
    throw new Error(result.message || "Failed to send enquiry");
  }

  return result;
};

export const adminLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = (token) =>
  api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
export const fetchEnquiries = (token) =>
  api.get("/enquiries", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);
